import React, { useState, useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Box,
  Typography,
  Breadcrumbs,
  Link,
  Stack,
  Card,
  CardContent,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useLocation, useNavigate } from "react-router-dom";
import "./AdditionalControl.css";
import logUserAction from "utils/logging";
const AdditionalControl = () => {
  const location = useLocation();
  const { stateName, siteId } = location.state || {};

  const [passwordVisible, setPasswordVisible] = useState(false);
  const [newPasswordVisible, setNewPasswordVisible] = useState(false);

  const [openModal, setOpenModal] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [nonCriticalLoadStatus, setNonCriticalLoadStatus] = useState(false);
  const [extraFanStatus, setExtraFanStatus] = useState(false);
  const [newLockPassword, setNewLockPassword] = useState(""); // Store the new password here
  const navigate = useNavigate();
  useEffect(() => {
    const userData = sessionStorage.getItem("userData");
    if (!userData) {
      navigate("/");
    } else {
      sessionStorage.setItem("lastVisitedPage", "/additional_control");
    }
  }, [navigate]);
  const breadcrumbs = [
    <Link key="1" sx={{ color: "black" }} href="/dashboard">
      Dashboard
    </Link>,
    <Link key="2" sx={{ color: "black" }} href={`/dashboard`}>
      {stateName}
    </Link>,
    <Link key="3" sx={{ color: "black" }} href={`/${stateName}/displaySite`}>
      Display Sites
    </Link>,
    <Typography key="4" sx={{ color: "text.primary" }}>
      Additional Control
    </Typography>,
  ];

  useEffect(() => {
    // Fetch additional controls for the site
    fetch(`https://api.bharatnet.sunshineiotronics.com/api/v2/profile_by_site/${siteId}`)
      .then((response) => response.json())
      .then((data) => {
        setNonCriticalLoadStatus(data.non_critical_load_control === 1);
        setExtraFanStatus(data.extra_fan_on_off_control === 1);
        setNewLockPassword(data.lock_pass); // Set initial password if fetched from the server
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [siteId]);

  const togglePasswordVisibility = () => {
    setPasswordVisible((prev) => !prev);
  };

  const toggleNewPasswordVisibility = () => {
    {
      /* Add this function */
    }
    setNewPasswordVisible((prev) => !prev);
  };

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setNewPassword("");
    setConfirmPassword("");
  };
  const handleChangePassword = async () => {
    // Check if the new password and confirm password match
    if (newPassword !== confirmPassword) {
      // Show a toast if passwords don't match
      toast.error("Passwords do not match. Please try again.", {
        autoClose: 3000,
      });
      return; // Exit the function if passwords don't match
    }

    // Proceed with password change if passwords match
    const modifiedData = {
      site_id: siteId,
      lock_pass: parseInt(newPassword),
    };
    console.log(modifiedData);

    try {
      const response = await fetch(
        "https://api.bharatnet.sunshineiotronics.com/api/v2/change_controller_pass",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(modifiedData),
        }
      );

      const data = await response.json(); // Wait for the response to be parsed as JSON
      console.log(data);

      if (response.status === 200) {
        // Use the response message from the data
        toast.success(data.message || "Lock Password changed successfully!", {
          autoClose: 2000,
        });
        logUserAction(`Password changed successfully for site ID: ${siteId}`);
        setTimeout(() => {
          handleCloseModal(); // Close the modal
          window.location.reload(); // Reload the page
        }, 2000);
      } else {
        toast.error(data.message || "Error changing password.", {
          autoClose: 3000,
        });
      }
    } catch (err) {
      toast.error("An unexpected error occurred.", {
        autoClose: 3000,
      });
      console.error(err);
    }
  };

  const toggleNonCriticalLoad = () => {
    const newStatus = !nonCriticalLoadStatus;
    setNonCriticalLoadStatus(newStatus);
    fetch(
      `https://api.bharatnet.sunshineiotronics.com/api/v2/toggle_non_critical_load/${siteId}`,
      {
        method: "GET",
      }
    ).catch((err) => console.error(err));
    logUserAction(
      newStatus ? "Turned ON Non-Critical Load" : "Turned OFF Non-Critical Load"
    );
  };

  const toggleExtraFan = () => {
    const newStatus = !extraFanStatus;
    setExtraFanStatus(newStatus);
    fetch(`https://api.bharatnet.sunshineiotronics.com/api/v2/toggle_extra_fan/${siteId}`, {
      method: "GET",
    }).catch((err) => console.error(err));
    logUserAction(newStatus ? "Turned ON Extra Fan" : "Turned OFF Extra Fan");
  };

  return (
    <Box m="1.5rem 2.5rem">
      <div className="container-fluid page-body-wrapper">
        <div className="main-panel">
          <div className="content-wrapper">
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Stack spacing={2}>
                <Breadcrumbs
                  separator={<NavigateNextIcon fontSize="medium" />}
                  aria-label="breadcrumb"
                >
                  {breadcrumbs}
                </Breadcrumbs>
              </Stack>
              <Typography variant="body1" sx={{ color: "text.secondary" }}>
                {siteId}
              </Typography>
            </Box>
          </div>
        </div>
      </div>
      <br /> <br />
      {/* Card with Additional Controls */}
      <Card>
        <CardContent>
          <Typography variant="h4" component="h4" gutterBottom>
            Additional Controls
          </Typography>

          <div className="row my-3">
            <div className="col-md-12">
              <table className="table table-bordered">
                <thead className="table-grey">
                  <tr>
                    <th className="fs-6">Control Name</th>
                    <th className="fs-6">Status</th>
                    <th className="fs-6">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {/* Lock Password */}
                  <tr>
                    <td>Lock Password</td>
                    <td className="text-center">
                      <div className="password-wrapper">
                        <span id="password-display">
                          {passwordVisible ? newLockPassword : "****"}
                        </span>
                        <Button
                          onClick={togglePasswordVisibility}
                          className="eye-button"
                          size="small"
                          variant="outlined"
                          color="secondary"
                        >
                          {passwordVisible ? (
                            <VisibilityOffIcon />
                          ) : (
                            <VisibilityIcon />
                          )}
                        </Button>
                      </div>
                    </td>
                    <td>
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        className="action-button"
                        onClick={handleOpenModal}
                      >
                        Change Password
                      </Button>
                    </td>
                  </tr>

                  {/* Non-Critical Load */}
                  <tr>
                    <td>Non-Critical Load</td>
                    <td id="non_critical_load_control">
                      {nonCriticalLoadStatus ? "ON" : "OFF"}
                    </td>
                    <td>
                      <Button
                        variant="contained"
                        color={nonCriticalLoadStatus ? "error" : "success"}
                        size="small"
                        className="action-button"
                        onClick={toggleNonCriticalLoad}
                      >
                        {nonCriticalLoadStatus ? "Turn OFF" : "Turn ON"}
                      </Button>
                    </td>
                  </tr>

                  {/* Extra Fan Control */}
                  <tr>
                    <td>Extra Fan Control</td>
                    <td id="extra_fan_on_off_control">
                      {extraFanStatus ? "ON" : "OFF"}
                    </td>
                    <td>
                      <Button
                        variant="contained"
                        color={extraFanStatus ? "error" : "success"}
                        size="small"
                        className="action-button"
                        onClick={toggleExtraFan}
                      >
                        {extraFanStatus ? "Turn OFF" : "Turn ON"}
                      </Button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </CardContent>
      </Card>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      {/* Modal for Change Password */}
      <Dialog open={openModal} onClose={handleCloseModal}>
        <DialogTitle>Change Password</DialogTitle>
        <DialogContent>
          <DialogContentText>Enter the new password below.</DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="newPassword"
            label="New Password"
            type={newPasswordVisible ? "text" : "password"}
            fullWidth
            variant="outlined"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <Button onClick={toggleNewPasswordVisibility}>
                  {newPasswordVisible ? (
                    <VisibilityOffIcon />
                  ) : (
                    <VisibilityIcon />
                  )}
                </Button>
              ),
            }}
          />

          <TextField
            margin="dense"
            id="confirmPassword"
            label="Confirm Password"
            type="password"
            fullWidth
            variant="outlined"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} color="error">
            Cancel
          </Button>
          <Button onClick={handleChangePassword} color="success">
            Change Password
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AdditionalControl;
